// extracted by mini-css-extract-plugin
module.exports = {"header":"SimpleHeader_header___sbvC"};